<template>
    <div class="cursor-pointer" @click="$emit('open-gallery', index)">
        <img class="impression-image" v-if="visible" :src="impression.url" :alt="impression.alt">
    </div>
</template>

<script>
    export default {
        name: "Impression",
        props: ['impression', 'visible', 'index']
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/js/components/Impression.vue